<template>
  <div>
    <Navbar />

    <section class="category-page">
      <Header
        formID="get-offer-company"
        :formData="formData"
        :insuranceType="insuranceType"
        approveRoute="isyeri-sigortasi-teklif-onay"
      />
      <get-quote :quoteCard="quoteCard" />
      <category-info :categoryInfo="categoryInfo" />
      <!-- <insurance-prices :insurancePrices="insurancePrices" /> -->
      <app-contracted-insurance-companies :buttons="buttonData" />
      <frequently-asked-questions
        :faqTitle="faqTitle"
        :faqTitleDesc="faqTitleDesc"
        :questions="questions"
      />
    </section>
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/component/navbar/Navbar'
import Header from '@/component/categories/Header'
import GetQuote from '@/component/categories/GetQuote'
import categoryInfo from '@/component/categories/CategoryInfo'
// import insurancePrices from '@/component/categories/InsurancePrices'
import appContractedInsuranceCompanies from '@/component/contracted-insurance-companies/AppContractedInsuranceCompanies'
import frequentlyAskedQuestions from '@/component/expansional-question-panel/AppQuestionPanel'
import CompanyInsuranceData from '@/data/category-page-data/CompanyInsurance'
import Footer from '@/component/footer/Footer'
import QuotationType from '@/data/QuotationType'
import { filteredButtons } from '@/mixins/FilteredButtons'

export default {
  metaInfo: {
    title: 'İş Yeri Sigortası Fiyatları İçin Teklif Alın',
    meta: [
      {
        name: 'description',
        content:
          'İşyeri sigortası genel şartları kapsamında en doğru işyeri paket sigortasını hesaplayın, işyeri sigortası fiyatlarını karşılaştırın.'
      }
    ]
  },
  mixins: [filteredButtons],
  name: 'CompanyInsurance',
  components: {
    Navbar,
    Header,
    GetQuote,
    categoryInfo,
    // insurancePrices,
    appContractedInsuranceCompanies,
    frequentlyAskedQuestions,
    Footer
  },
  data () {
    return {
      insuranceType: QuotationType.COMPANY,
      categoryInfo: CompanyInsuranceData.categoryInfo,
      getPrice: CompanyInsuranceData.getPrice,
      faqTitle: CompanyInsuranceData.faqTitle,
      faqTitleDesc: CompanyInsuranceData.faqTitleDesc,
      questions: CompanyInsuranceData.questions,
      formData: {
        description: {
          upperText: 'Doğru Kapsam, En İyi Fiyat',
          title: 'En Uygun İş Yeri Sigortası Fiyatları',
          bottomText: 'İş Yeri Sigortası Tekliflerini Karşılaştırın'
        },
        button: 'TEKLİF AL',
        fullname: true,
        identity: true,
        phone: true,
        email: true
      },
      quoteCard: {
        title: 'Alokasko İle İş Yeri Sigortası Satın Almak Çok Kolay!',
        description:
          'İş yeri sigortası ile işletmenizdeki riskleri kontrol altına alın.',
        content: [
          {
            id: 1,
            icon: 'fas fa-file-alt',
            title: 'İhtiyaca Özel Poliçe',
            desc:
              'En doğru teminatları seçerek, iş yeri sigortası ile işyerinizi ve çalışanlarınızı güvence altına alabilirsiniz.'
          },
          {
            id: 2,
            icon: 'fab fa-cc-visa',
            title: 'Farklı Paket Seçenekleri',
            desc:
              'İş yeri sigortası ile zengin asistans ve ek hizmetlerden yararlanabilirsiniz.'
          },
          {
            id: 3,
            icon: 'fas fa-clipboard-check',
            title: 'Online Satın Alma',
            desc:
              'Çok sayıda mevcut fiyat teklifi arasından ihtiyaçlarınıza ve bütçenize en uygun olanı seçebilirsiniz.'
          },
          {
            id: 4,
            icon: 'fas fa-users-cog',
            title: 'Uzman Desteği',
            desc:
              'Kolay ödeme avantajı ile kredi kartına özel taksit imkânından yararlanın, poliçenizi hemen alın.'
          }
        ]
      }
    }
  },
  mounted () {
    this.filterButtons('İşyeri Sigortası')
  }
}
</script>
<style lang="scss">
@import '@/css/app.scss';
</style>
